<template>
  <div class="softwareDev-cont bg-carbon-fiber">
    <div class="content">
      <div class="section-header">
        <h2>Software Development</h2>
      </div>
      <div class="row tech-row">
        <div class="col-sm-3 col-xs-12">
          <div class="single-work show-overflow s-dev">
            <img
              class="tech-img-size"
              src="../assets/images/tech-icons/vuejs.png"
              alt="VueJS"
            />
            <div class="item-hover2">
              <div class="work-table">
                <div class="work-tablecell">
                  <div class="hover-content">
                    <h4>Vue.js</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3 col-xs-12">
          <div class="single-work show-overflow s-dev">
            <img
              class="tech-img-size App-logo"
              src="../assets/images/tech-icons/tech-react-logo.png"
              alt="VueJS"
            />
            <div class="item-hover2">
              <div class="work-table">
                <div class="work-tablecell">
                  <div class="hover-content">
                    <h4>React</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3 col-xs-12">
          <div class="single-work show-overflow s-dev">
            <img
              class="tech-img-size"
              src="../assets/images/tech-icons/tech-node-logo.png"
              alt="VueJS"
            />
            <div class="item-hover2">
              <div class="work-table">
                <div class="work-tablecell">
                  <div class="hover-content">
                    <h4>Node.js</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3 col-xs-12">
          <div class="single-work show-overflow s-dev">
            <img
              class="tech-img-size"
              src="../assets/images/tech-icons/tech-mysql-logo.png"
              alt="VueJS"
            />
            <div class="item-hover2">
              <div class="work-table">
                <div class="work-tablecell">
                  <div class="hover-content">
                    <h4>MySQL<br />Database</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.softwareDev-cont {
  .content {
    .section-header {
      padding: 4rem 1rem 2rem;
    }
    .tech-row {
      padding: 1rem 1rem 2.5rem;
      margin: auto;
      max-width: 1050px;
    }
    .single-work {
      position: relative;
      overflow: hidden;
      margin-bottom: 30px;
      text-align: center;
    }
    .single-work img {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-transition: all 0.5s ease 0s;
      transition: all 0.5s ease 0s;
    }
    .single-work:hover img {
      -webkit-transform: scale(1.25);
      transform: scale(1.25);
    }
    .s-dev img {
      -webkit-transform: scale(1);
      transform: scale(1);
      -webkit-transition: all 0.5s ease 0s;
      transition: all 0.5s ease 0s;
    }
    .s-dev:hover img {
      -webkit-transform: scale(1.25);
      transform: scale(1.25);
      opacity: 0.4;
    }
    .item-hover {
      padding: 30px;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      z-index: 1;
      opacity: 0;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      -webkit-transition: 0.6s;
      transition: 0.6s;
    }
    .item-hover:before {
      position: absolute;
      content: "";
      background-color: #000;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      visibility: hidden;
      z-index: -1;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .single-work:hover .item-hover:before {
      opacity: 0.7;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      visibility: visible;
    }
    .single-work:hover .item-hover {
      opacity: 1;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    }

    /* item-h0ver2 */
    .item-hover2 {
      padding: 30px;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      z-index: 1;
      opacity: 0;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      -webkit-transition: 0.6s;
      transition: 0.6s;
    }
    .item-hover2:before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      visibility: hidden;
      z-index: -1;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .single-work:hover .item-hover2:before {
      opacity: 0.7;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
      visibility: visible;
    }
    .single-work:hover .item-hover2 {
      opacity: 1;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
    }

    .work-table {
      display: table;
      height: 100%;
      text-align: center;
      width: 100%;
    }
    .work-tablecell {
      display: table-cell;
      vertical-align: middle;
    }
    .single-work:hover .hover-content {
    }
    .hover-content h4,
    .hover-content p {
      color: #fff;
      margin: 0;
    }
    .hover-content h4 {
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 21px;
    }
    .hover-content p {
      font-weight: 400;
      font-size: 14px;
    }
    .hover-content a {
      display: inline-block;
      font-size: 18px;
      height: 45px;
      line-height: 45px;
      color: #fff;
      margin-top: 10px;
      text-align: center;
      -webkit-transition: all 0.6s ease 0s;
      transition: all 0.6s ease 0s;
      width: 45px;
      transition: 0.6s;
      border-radius: 50%;
    }
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
      height: 160px;
    }

    .App-title {
      font-size: 1.5em;
    }

    .App-intro {
      font-size: large;
    }

    @keyframes App-logo-spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .tech-img-size {
      height: 160px;
      display: inline-block;
      vertical-align: middle;
    }
    .marg-auto {
      margin: auto;
    }
    .show-overflow {
      overflow: visible !important;
    }
  }
}

.bg-carbon-fiber {
  background-color: rgb(32, 32, 32);
  background-image: linear-gradient(
      45deg,
      black 25%,
      transparent 25%,
      transparent 75%,
      black 75%,
      black
    ),
    linear-gradient(
      45deg,
      black 25%,
      transparent 25%,
      transparent 75%,
      black 75%,
      black
    ),
    linear-gradient(to bottom, rgb(8, 8, 8), rgb(32, 32, 32));
  background-size: 10px 10px, 10px 10px, 10px 5px;
  background-position: 0px 0px, 5px 5px, 0px 0px;
  background-repeat: repeat;
}
</style>